import * as Scrivito from "scrivito"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"

import { ProjectTeamInvitationListPageConnector } from "pages/project-team-invitation-list-page/ProjectTeamInvitationListPageConnector"

import { ProjectTeamInvitationListPageObjClass } from "./ProjectTeamInvitationListPageObjClass"

Scrivito.provideComponent(ProjectTeamInvitationListPageObjClass, ({ page }) => {
  useScrivitoPage()
  return <ProjectTeamInvitationListPageConnector page={page} />
})
